import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.addEventListener("submit", this.handleSubmit.bind(this))
    this.element.addEventListener("turbo:submit-end", this.removeOverlay.bind(this))
  }

  disconnect() {
    this.removeOverlay()
  }

  handleSubmit(event) {
    // El confirm del button_to ya se maneja con data-confirm de Rails
    // Si llegamos acá, el usuario ya confirmó
    this.showLoadingOverlay()
  }

  showLoadingOverlay() {
    const messages = [
      "Preparando la nota de crédito...",
      "Revisando la receta original...",
      "Deshaciendo el plato fiscal...",
      "Comunicando con AFIP...",
      "Casi listo, ajustando los números...",
      "El chef está procesando la anulación...",
      "Emplatando la nota de crédito..."
    ]

    const overlay = document.createElement('div')
    overlay.className = 'invoice-loading-overlay'
    overlay.id = 'credit-note-loading-overlay'
    overlay.innerHTML = `
      <div class="invoice-loading-content">
        <div class="invoice-loading-receipt">
          <div class="receipt-printer">
            <div class="printer-body">
              <div class="printer-slot"></div>
            </div>
            <div class="receipt-paper">
              <div class="receipt-line"></div>
              <div class="receipt-line short"></div>
              <div class="receipt-line"></div>
              <div class="receipt-line medium"></div>
              <div class="receipt-line short"></div>
            </div>
          </div>
        </div>
        <p class="invoice-loading-message">${messages[0]}</p>
        <div class="invoice-loading-dots">
          <span></span><span></span><span></span>
        </div>
      </div>
    `
    document.body.appendChild(overlay)

    let index = 0
    this.messageInterval = setInterval(() => {
      index = (index + 1) % messages.length
      const msgEl = overlay.querySelector('.invoice-loading-message')
      if (msgEl) {
        msgEl.style.opacity = '0'
        setTimeout(() => {
          msgEl.textContent = messages[index]
          msgEl.style.opacity = '1'
        }, 300)
      }
    }, 2500)
  }

  removeOverlay() {
    if (this.messageInterval) {
      clearInterval(this.messageInterval)
      this.messageInterval = null
    }
    const overlay = document.getElementById('credit-note-loading-overlay')
    if (overlay) {
      overlay.remove()
    }
  }
}
